import * as React from 'react';
import Button from 'antd/lib/button';
import Divider from 'antd/lib/divider';
import Form, { FormComponentProps } from 'antd/lib/form';
import Alert from 'antd/lib/alert';
import Row from 'antd/lib/row';
import TextField from '../../Components/TextField';
import { ICredencial } from '../../Models/Security';
import TextPass from '../../Components/TextField/TextPass';
import './BoxForm.scss';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { WrappedFormUtils } from 'antd/lib/form/Form';

export interface IBoxFormProps extends FormComponentProps {
	onLogIn: (cred: ICredencial) => void;
	onRecoveryShow: () => void;
	message?: string;
	isChecking: boolean;
}

const rulesEmail = [
	{
		required: true,
		message: 'El Correo Corporativo es requerido*'
	},
	{
		type: 'email',
		message: 'Debe escribir un correo válido*'
	}
];

const BoxForm = (props: IBoxFormProps) => {
	const hasError = (form: WrappedFormUtils, name: string) => {
		const err = form.getFieldError(name);
		if (err === undefined) {
			return false;
		}
		if (err.length === 0) {
			return false;
		}
		return true;
	}
	const getError = (form: WrappedFormUtils, name: string) => {
		const err = form.getFieldError(name);
		return err;
	}
	const { getFieldDecorator } = props.form;
	const onSubmit = (evt: React.FormEvent) => {
		evt.preventDefault();
		props.form.validateFields((errs, values) => {
			if (errs) {
				return;
			}
			props.onLogIn(values);
		});
	};
	return (
		<div className='box-form'>
			<Form onSubmit={onSubmit}>
				<h2>Bienvenido</h2>
				<p>Con esta plataforma podras ver el estado de tus cargas en Puerto Angamos</p>
				<Row className='box-text-field'>
					<FormControl
								style={{ width: '100%' }} error={hasError(props.form, 'username')}>
						{getFieldDecorator('username', {
							rules: rulesEmail
						})(
							<TextField
								label='Correo corporativo'
								variant='outlined'
								margin='normal'
							/>
						)}
						{hasError(props.form, 'username') && <FormHelperText >{getError(props.form, 'username')}</FormHelperText>}
					</FormControl>
					<FormControl
								style={{ width: '100%' }} error={hasError(props.form, 'password')}>
						{getFieldDecorator('password', {
							rules: [{
								required: true,
								message: 'La contraseña es requerida'
							}]
						})(
							<TextPass
								style={{ width: '100%' }}
								label='Contraseña'
								variant='outlined'
								margin='normal'
							/>
						)}
						{hasError(props.form, 'password') && <FormHelperText >{getError(props.form, 'password')}</FormHelperText>}
					</FormControl>
				</Row>
				<Button disabled={props.isChecking} htmlType="submit" type='primary' block>
					Iniciar Sesión
        </Button >
				{props.message && <Alert
					message={props.message}
					banner
				/>}
				<Divider />
				<div className='box-forget-password'>
					¿Olvidaste tu Contraseña? <Button disabled={props.isChecking} type='link' onClick={props.onRecoveryShow} >Selecciona aquí</Button>
				</div>
			</Form>
		</div>
	);
};

export default Form.create<IBoxFormProps>()(BoxForm);
